import script from "./OrderProductionSummaryTable.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderProductionSummaryTable.vue?vue&type=script&setup=true&lang=js"

import "./OrderProductionSummaryTable.vue?vue&type=style&index=0&id=c8f5853e&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8f5853e"]])

export default __exports__